import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { StudioSessionsStoreEffects } from './effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('studio-sessions', reducer),
        EffectsModule.forFeature([StudioSessionsStoreEffects]),
    ],
    providers: [],
})
export class StudioSessionsStoreModule { }
